import { render, staticRenderFns } from "./yewutichengyijubiao.vue?vue&type=template&id=25f88b0c&scoped=true&"
import script from "./yewutichengyijubiao.vue?vue&type=script&lang=js&"
export * from "./yewutichengyijubiao.vue?vue&type=script&lang=js&"
import style0 from "./yewutichengyijubiao.vue?vue&type=style&index=0&id=25f88b0c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f88b0c",
  null
  
)

export default component.exports